<template>
  <CustomDrawer
    v-model="isDrawerOpen"
    direction="right"
    title="I Assistant"
    width="500px"
    top="0px"
  >
    <template #subtitle>
      <span class="text-xs secondary_color">Your AI-powered assistant</span>
    </template>

    <AgiChat :isDrawerMode="true" />
  </CustomDrawer>
</template>

<script setup>
import { computed } from "vue";
import CustomDrawer from "@/src/components/CustomDrawer.vue";
import AgiChat from "@/src/views/chats/AgiChat.vue";

const props = defineProps({
  modelValue: {
    type: Boolean,
    required: true,
  },
});

const emit = defineEmits(["update:modelValue"]);

const isDrawerOpen = computed({
  get: () => props.modelValue,
  set: (value) => emit("update:modelValue", value),
});
</script>
